module.exports = __webpack_public_path__ + "img/powered4.bc395fee.png";